import React from 'react';

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
  variant?: 'full' | 'icon' | 'text';
}

const Logo: React.FC<LogoProps> = ({ 
  width = 160, 
  height = 40, 
  className = "", 
  variant = 'full' 
}) => {
  if (variant === 'icon') {
    return (
      <svg 
        width={width} 
        height={height} 
        viewBox="0 0 40 40" 
        className={className}
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Icon - L symbol with modern geometric design */}
        <rect width="40" height="40" rx="8" fill="#111827"/>
        <path 
          d="M12 10h4v16h8v4H12V10z" 
          fill="#ffffff"
        />
        <path 
          d="M22 14h6v2h-6v-2z" 
          fill="#6366f1" 
          opacity="0.8"
        />
        <path 
          d="M22 18h4v2h-4v-2z" 
          fill="#6366f1" 
          opacity="0.6"
        />
      </svg>
    );
  }

  if (variant === 'text') {
    return (
      <svg 
        width={width} 
        height={height} 
        viewBox="0 0 160 40" 
        className={className}
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Text only */}
        <text 
          x="0" 
          y="28" 
          fontFamily="system-ui, -apple-system, sans-serif" 
          fontSize="20" 
          fontWeight="700" 
          fill="currentColor"
        >
          latant
        </text>
        <text 
          x="80" 
          y="28" 
          fontFamily="system-ui, -apple-system, sans-serif" 
          fontSize="20" 
          fontWeight="400" 
          fill="currentColor" 
          opacity="0.7"
        >
          consulting
        </text>
      </svg>
    );
  }

  // Full logo (default)
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 200 40" 
      className={className}
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Logo mark - Modern L with accent */}
      <rect width="32" height="32" rx="6" fill="#111827" y="4"/>
      <path 
        d="M10 12h3v12h6v3H10V12z" 
        fill="#ffffff"
      />
      <path 
        d="M17 15h4v1.5h-4v-1.5z" 
        fill="#6366f1" 
        opacity="0.8"
      />
      <path 
        d="M17 18h3v1.5h-3v-1.5z" 
        fill="#6366f1" 
        opacity="0.6"
      />
      
      {/* Company name */}
      <text 
        x="44" 
        y="28" 
        fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" 
        fontSize="18" 
        fontWeight="700" 
        fill="currentColor"
      >
        latant
      </text>
      <text 
        x="104" 
        y="28" 
        fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" 
        fontSize="18" 
        fontWeight="400" 
        fill="currentColor" 
        opacity="0.7"
      >
        consulting
      </text>
    </svg>
  );
};

export default Logo;